import {Component, OnInit, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import {ApiService} from '../../services/api.service';
import {UserService} from '../../services/user.service';
import {HttpResponse} from '@angular/common/http';
import {Group} from '../../models/group.model';
import { SortTableService } from '../../services/sort-table.service';
import { User } from '../../models/user.model';
import { DepartmentTree } from '../../models/department-tree';

const GROUP_LIST = 'myGroupList';
const SORT_FIELD = 'title';
const NO_CONTENT = 204;

@Component({
  selector: 'app-my-groups',
  templateUrl: './my-groups.component.html',
  styleUrls: ['./my-groups.component.css']
})
export class MyGroupsComponent implements OnInit, OnDestroy {
  public noGroupsInfo = true;
  public getGroupsErrorInfo = false;
  public isLoaded = false;
  public myGroupList: Group[] = [];
  tree = new DepartmentTree();
  private destroy$ = new Subject<void>();
  private mainGroup;
  user: User;
  flag = true;
  isAdmin = false;
  isHead = false;
  isUser = false;

  constructor(private apiService: ApiService,
              private userService: UserService,
              public sortTableService: SortTableService ) {
                this.mainGroup = JSON.parse(localStorage.getItem('User')).mainGroup;
  }

  ngOnInit(): void {
    this.apiService.getMyGroups(this.userService.getLocal().id).takeUntil(this.destroy$)
      .subscribe(response => this.acceptGroups(response), () => this.rejectGroups());
    this.checkRole();
  }

  ngOnDestroy(): void { this.destroy$.next(); this.destroy$.complete(); }

  private acceptGroups(response: HttpResponse<Object>): void {
    const groups = response.status === NO_CONTENT ? [] : response.body;
    if (!Array.isArray(groups)) { this.rejectGroups(); return; }
    this.myGroupList = groups as Group[];
    this.sortTableService.sortList(GROUP_LIST, this.myGroupList, SORT_FIELD);
    this.tree.setGroups(this.myGroupList);
    this.noGroupsInfo = !this.myGroupList.length;
    this.getGroupsErrorInfo = false;
    this.isLoaded = true;
  }

  private rejectGroups(): void {
    this.noGroupsInfo = this.getGroupsErrorInfo = this.isLoaded = true;
  }

  checkRole() {
    this.user = this.userService.getLocal();
    if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
			this.isHead = true;
		} else {
			this.isHead = false;
		}
		if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
			this.isAdmin = true;
		} else {
			this.isAdmin = false;
		}
		if (this.user.roles.indexOf('ROLE_USER') !== -1) {
			this.isUser = true;
		} else {
			this.isUser = false;
		}
  }

  sortGroups(): void {
    this.sortTableService.sortList(GROUP_LIST, this.myGroupList, SORT_FIELD, true);
    this.tree.setGroups(this.myGroupList);
  }

  trackByGroupId(index: number, group: Group): string {
    return group.id;
  }

  isSelectedGroup(name) {
      if(name.includes('*')) {
        return true
      } else {
        return false
      }
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-groups/my-groups.component.ts